// extracted by mini-css-extract-plugin
export default {"root":"Player_root__Tstzv","hide-cursor":"Player_hide-cursor__UxUHD","debug":"Player_debug__kiyBK","large-screen-mode":"Player_large-screen-mode__4ZXU7"};